// event-bus.js
import Vue from 'vue'
export default new Vue